import React from 'react';
import HoverTip from '../../page/km/components/hover-tip';
import Icon from '@/components/Icon';
import './style.less';

const PricingTableTextEnum = {
  1: 'raw-right',
  0: 'raw-error',
};

const ThemeColorEnums = {
  1: '#4D8DF7',
  2: '#FF9A00',
  3: '#FF4F25',
};

const clsPrefix = 'new-plan-table';
const SubTable = ({ dataSource, themeColors }) => {
  const tdData = dataSource.title ? dataSource.data.slice(1) : dataSource.data;
  const cols = [];
  for (let i = 0; i < dataSource.data[0].length - 1; i += 1) {
    cols.push(
      <col
        key={i}
        style={{
          width: `${((949 - 280) / (dataSource.data[0].length - 1) / 949) * 100}%`,
        }}
      />
    );
  }
  return (
    <table className={`${clsPrefix}__table`} id={dataSource.id}>
      <colgroup>
        {dataSource.title ? (
          <React.Fragment>
            <col style={{ width: `${(117 / 949) * 100}%` }} />
            <col style={{ width: `${(162 / 949) * 100}%` }} />
          </React.Fragment>
        ) : (
          <col style={{ width: `${(281 / 949) * 100}%` }} />
        )}
        {cols}
      </colgroup>
      <tbody>
        <tr>
          {dataSource.title && (
            <React.Fragment>
              <th scope="rowgroup" rowSpan={dataSource.data.length}>
                {dataSource.title}
                {dataSource.desc && <HoverTip className="description-tip" msg={dataSource.desc} />}
              </th>
              {dataSource.data[0].map((item, index) => {
                const tdChildren = Object.keys(PricingTableTextEnum).indexOf(item.text) > -1 || Object.keys(PricingTableTextEnum).indexOf(item) > -1 ? <Icon name={PricingTableTextEnum[item.text || item]} style={{ color: themeColors[index], fontSize: '22px' }} /> : item.text || item;
                return (
                  <td>
                    {tdChildren}
                    {item.hint && <HoverTip className="description-tip" msg={item.hint} />}
                  </td>
                );
              })}
            </React.Fragment>
          )}
        </tr>
        {tdData.map(items => (
          <tr>
            {items.map((item, index) => {
              const tdChildren = Object.keys(PricingTableTextEnum).indexOf(item.text) > -1 || Object.keys(PricingTableTextEnum).indexOf(item) > -1 ? <Icon name={PricingTableTextEnum[item.text || item]} style={{ color: themeColors[index], fontSize: '22px' }} /> : item.text || item;
              return (
                <td>
                  {tdChildren}
                  {item.hint && <HoverTip className="description-tip" msg={item.hint} />}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

SubTable.defaultProps = {
  themeColors: ThemeColorEnums,
};

export default SubTable;
